<template>
  <div class="about-container">
    <div class="banner">
      <img v-lazy="banner" alt>
    </div>
    <div class="content">
      <div class="company-intro" :class="{active: isIndex == 0}">
        <div class="tit">
          <h2>公司简介</h2>
          <span>COMPANY PROFILE</span>
        </div>
        <div class="section">
          <p>海南盈趣互动娱乐公司成立于2015年，注册资金1100万元。是一家从事游戏研发，游戏运营以及计算机网络技术服务的互联网公司。海南盈趣互动娱乐是业内领先的游戏泛运营服务提供商，系一群沉浸于游戏行业多年的资深运营、技术专业人才创建，我们比玩家更懂游戏，比游戏产商更了解玩家。本着为玩家找到好游戏，为好游戏找到玩家的使命。</p>
          <p>牛牛正依托深度合作的游戏产商资源，立体的互联网推广渠道资源，创新的泛运营模式，专业、有效的大数据分析应用能力，同时我们用心服务专注技术，我们的宗指是构建多维度的游戏大数据库打造全赢的游戏运营产业。</p>
        </div>
      </div>
      <div class="company-history" :class="{active: isIndex == 1}">
        <div class="tit">
          <h2>发展历程</h2>
          <span>DEVELOPMENT HISTORY</span>
        </div>
        <div class="history-content">
          <ul class="history-tab">
            <li
              v-for="(item,index) in history"
              :key="index"
              @click="handelTab(index,item.id)"
              :class="{active:isActive==index}"
            >
              {{item.years}}
              <span>></span>
            </li>
          </ul>
          <transition name="fade-right">
            <div class="history-tabcon" v-if="isShow">
              <ul>
                <li v-for="(item,index) in historyInfo" :key="index">
                  <p>{{item}}</p>
                </li>
              </ul>
            </div>
          </transition>
        </div>
      </div>
      <div class="company-honor" :class="{active: isIndex == 2}">
        <div class="tit">
          <h2>公司荣誉</h2>
          <span>COMPANY HONOR</span>
        </div>
        <ul>
          <li>
            <div class="honor-tit">2017获得福建省科技型中小企业</div>
            <img src="../assets/image/prize2.png" alt>
          </li>
          <li>
            <div class="honor-tit">2017获得高新技术企业</div>
            <img src="../assets/image/prize3.png" alt>
          </li>
          <li>
            <div class="honor-tit">2017业绩首创亿元大关</div>
            <img src="../assets/image/prize1.png" alt>
          </li>
        </ul>
      </div>
      <div class="contact-us" :class="{active: isIndex == 3}">
        <div class="tit">
          <h2>联系我们</h2>
          <span>CONTACT US</span>
        </div>
        <div class="contact-us-content">
          <div class="contact-person">
            <div class="item">
              <h3>联运游戏合作</h3>
              <span>刘俊伟</span>
              <em>3394718918</em>
              <p>3394718918@qq.com</p>
            </div>
            <div class="item">
              <h3>平台问题反馈</h3>
              <span>牛牛客服</span>
              <em>3004929660</em>
              <p>3004929660@qq.com</p>
            </div>
          </div>
          <div class="map">
            <img src="../assets/image/map.png" alt>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banner: require("../assets/image/about_bg.jpg"),
      history: [
        {
          years: "2015年",
          info: [
            "6月 海南盈趣互动娱乐公司成立了",
            "6月 官网上线了",
            "8月 第一款平台端游戏《圣斗士星矢》上线"
          ]
        },
        {
          years: "2016年",
          info: ["6月 牛牛SDK研发完成"]
        },
        {
          years: "2017年",
          info: ["5月 接下第一款官方通服游戏《西游记之大圣归来》"]
        }
      ],
      isActive: 0,
      historyInfo: [],
      isShow: true,
      positionArr: [],
      isIndex: ""
    };
  },
  methods: {
    handelTab: function(index) {
      if (this.isActive !== index) {
        this.isActive = index;
        this.historyInfo = this.history[index].info;
      }
    },
    scrollspy: function(top) {
      let currentTop = 0;
      let requestId;
      let speed = 40;
      function step() {
        currentTop += speed;
        if (currentTop <= top) {
          window.scrollTo(0, currentTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(requestId);
        }
      }
      window.requestAnimationFrame(step);
    },
    removeClass: function() {
      setTimeout(() => {
        this.isIndex = 10;
      }, 2200);
    }
  },
  mounted: function() {
    let curIndex = this.$route.query.index;
    this.historyInfo = this.history[0].info;
    setTimeout(() => {
      let elements = document.querySelectorAll(".tit");
      for (let i = 0; i < elements.length; i++) {
        this.positionArr.push(elements[i].offsetTop);
      }
      this.scrollspy(this.positionArr[curIndex]);
      //this.isIndex = curIndex;
      this.$router.push({
        path: "/about"
      });
      this.removeClass();
    }, 500);
  },
  watch: {
    $route(to, from) {
      let index = from.query.index;
      this.scrollspy(this.positionArr[index]);
      this.isIndex = index;
      this.$router.push({
        path: "/about"
      });
      this.removeClass();
    }
  }
};
</script>

<style scoped>
.banner img {
  width: 100%;
}
.about-container .tit {
  border-bottom: 1px solid #ddd;
  line-height: 1.4;
  padding-bottom: 7px;
}
.about-container .tit h2 {
  font-size: 30px;
  font-weight: bold;
  background: url(../assets/image/arrow_icon.png) no-repeat right center;
  display: inline-block;
  padding-right: 30px;
}
.about-container .tit span {
  display: block;
  color: #a6a6a6;
}

.company-intro {
  padding: 70px 0;
}

.company-intro .section {
  padding: 10px 100px 0 258px;
}

.company-intro .section p {
  text-indent: 2em;
  font-size: 16px;
  line-height: 30px;
  margin-top: 20px;
}

.company-intro.active .section p {
  opacity: 0;
  animation: fadeInUp 1s 0.3s forwards;
}
.company-intro.active .section p:last-child {
  opacity: 0;
  animation-delay: 0.8s;
}

.history-content {
  overflow: hidden;
  padding: 35px 20px 70px 260px;
}

.history-tab {
  width: 17.8%;
  float: left;
  border: 1px solid #ebebeb;
  border-bottom: none;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 30px;
}

.history-tab li {
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  border-bottom: 1px solid #ebebeb;
  cursor: pointer;
}

.company-history.active .history-tab {
  opacity: 0;
  animation: fadeInLeft 1s 0.3s forwards;
}

.history-tab li.active {
  background-color: #ebebeb;
  color: #e23251;
}

.history-tab li span {
  display: inline-block;
  opacity: 0;
  transition: all 0.3s;
}

.history-tab li.active span {
  opacity: 1;
  transform: translateX(20px);
}

.history-tabcon {
  float: left;
  width: 60%;
  position: relative;
}
.history-tabcon li {
  font-size: 16px;
  position: relative;
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.history-tabcon ul::before {
  content: "";
  width: 10px;
  height: 20px;
  position: absolute;
  left: -5px;
  top: 0;
  background-color: #fff;
}

.history-tabcon ul::after {
  content: "";
  width: 10px;
  height: 20px;
  position: absolute;
  left: -5px;
  bottom: -3px;
  background-color: #fff;
}

.history-tabcon::before {
  content: "";
  position: absolute;
  height: 100%;
  border-left: 1px solid #dfdedf;
  left: 0;
}

.history-tabcon li::before {
  content: "";
  width: 10px;
  height: 10px;
  background-color: #e44962;
  border-radius: 50%;
  display: block;
  position: absolute;
  left: -5px;
  top: 50%;
  margin-top: -5px;
  z-index: 5;
}

.company-history.active .history-tabcon {
  opacity: 0;
  animation: fadeIn 1s .8s forwards;
}

.contact-us-content {
  padding: 0 0 30px 0;
}

.company-honor ul {
  padding: 52px 20px 70px 260px;
}

.company-honor li {
  padding-bottom: 17px;
}

.company-honor.active li {
  opacity: 0;
  animation: bounceInDown 1s 0.3s forwards;
}
.company-honor.active li:nth-child(2) {
  animation-delay: 0.8s;
}
.company-honor.active li:nth-child(3) {
  animation-delay: 1.3s;
}

.company-honor .honor-tit {
  font-size: 16px;
  line-height: 38px;
  background: url(../assets/image/prize_icon.png) no-repeat left center;
  padding-left: 50px;
  margin-bottom: 10px;
}

.company-honor img {
  width: 232px;
  height: 140px;
  display: block;
  margin-left: 50px;
}

.contact-person {
  width: 220px;
}

.contact-person .item {
  padding-top: 25px;
}

.contact-person h3 {
  font-size: 16px;
  font-weight: bold;
}

.contact-person span {
  display: inline-block;
  font-size: 14px;
  background: url(../assets/image/ic_qq.png) no-repeat right center;
  padding-right: 22px;
  margin: 7px 7px 7px 0;
}
.contact-person p {
  font-size: 14px;
  color: #181c1f;
}

.contact-us-content {
  overflow: hidden;
}

.contact-us-content .map {
  margin-top: 20px;
}

.contact-us.active .contact-us-content .map img {
  opacity: 0;
  animation: fadeInRight 1s 0.8s forwards;
}

.contact-us-content .map img {
  width: 100%;
}

.contact-us.active .contact-person .item {
  opacity: 0;
  animation: fadeInLeft 1s 0.5s forwards;
}

.contact-us.active .contact-person .item:last-child {
  animation-delay: 0.8s;
}

.fade-right-enter-active {
  animation: fadeRight 1s;
}
.fade-right-leave-active {
  animation: fadeRight 1s;
}

.company-intro .section {
  padding: 0;
}
.history-content {
  overflow: hidden;
  padding: 35px 0;
}

@keyframes fadeRight {
  0% {
    opacity: 0;
    transform: translateX(-20px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 767px) {
  .history-tab li {
    text-align: center;
    font-size: 13px;
  }
  .history-tab li span {
    display: none;
  }

  .history-tabcon::before {
    display: none;
  }
  .company-honor ul {
    padding: 30px 0 40px 0;
  }
  .contact-us-content .map {
    width: 100%;
    text-align: center;
  }
  .contact-person {
    text-align: center;
    width: 100%;
  }
}

@media (max-width: 767px) {
  .company-intro {
    padding: 30px 0;
  }
}

@media (min-width: 768px) {
  .contact-us-content .map {
    width: 100%;
    text-align: center;
  }
  .contact-person {
    text-align: center;
    width: 100%;
  }
}
@media (min-width: 992px) {
  .company-intro .section {
    padding: 10px 100px 0 258px;
  }
  .history-content {
    overflow: hidden;
    padding: 35px 20px 70px 260px;
  }

  .contact-person {
    width: 24%;
    float: left;
  }

  .contact-us-content {
    padding: 30px 0 50px 260px;
  }
  .contact-us-content .map {
    width: 60%;
    float: left;
  }
}
@media (min-width: 1200px) {
}

@keyframes bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0);
  }

  75% {
    opacity: 1;
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
  }

  90% {
    opacity: 1;
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
</style>

                        
                        
  
                        
